function getHtml(icon: string, additionalClass?: string) {
  let classAttribute = `tn-icon tn-icon--${icon}`;

  if (additionalClass) {
    classAttribute += ` ${additionalClass}`;
  }

  return `<svg aria-hidden="true" class="${classAttribute}"><use xlink:href="/_images/sprites.svg#${icon}" /></svg>`;
}

function getElement(icon: string, additionalClass?: string) {
  const $temp = document.createElement('div');

  $temp.innerHTML = getHtml(icon, additionalClass);

  return $temp.firstElementChild as SVGElement;
}

export default {
  getHtml,
  getElement,
};
